import { SidebarProvider } from "@/Components/ui/sidebar";
import { useEffect } from "react";
import { Item, Option, Stage } from "../../types/productTypes";
import MainEditorPanel from "./Editor/MainEditorPanel";
import { AdminSidebar } from "./Sidebar/AdminSidebar";
import { ExplorerSidebar } from "./Sidebar/ExplorerSidebar";
import { useAdminStore } from "../../store/useAdminStore";

// Types from your Prisma schema
// Assuming you have generated TypeScript types from Prisma

// Extend MainProduct to include relations

export default function MainAdminPage() {
   const adminStore = useAdminStore();
   const selectedProductId = adminStore.selectedProductId;
   const selectedStageId = adminStore.selectedStageId;
   const selectedOptionId = adminStore.selectedOptionId;
   const selectedItemId = adminStore.selectedItemId;
   useEffect(() => {
      adminStore.fetchProducts();
      adminStore.fetchOptionPairs();
   }, []);
   useEffect(() => {
      console.log("allProducts", adminStore.allProducts);
   }, [adminStore.allProducts]);

   useEffect(() => {
      if (!selectedProductId) return;
      adminStore.fetchAllOptions(selectedProductId);
      adminStore.fetchProductOptionPairs(selectedProductId);
   }, [selectedProductId]);
   useEffect(() => {
      if (!selectedProductId) return;
      adminStore.fetchConfigs(selectedProductId);
   }, [selectedProductId]);

   const currentProduct =
      selectedProductId !== null
         ? adminStore.allProducts.find(
              (product) => product.id === selectedProductId
           )
         : null;

   let currentStage: Stage | null = null;
   let currentOption: Option | null = null;
   let currentItem: Item | null = null;

   if (currentProduct && selectedStageId !== null) {
      currentStage =
         currentProduct.stages.find((stage) => stage.id === selectedStageId) ||
         null;
      if (currentStage && selectedOptionId !== null) {
         currentOption =
            currentStage.options?.find(
               (option) => option.id === selectedOptionId
            ) || null;
         if (currentOption && selectedItemId !== null) {
            currentItem =
               currentOption.items?.find(
                  (item) => item.id === selectedItemId
               ) || null;
         }
      }
   }
   console.log("changing");
   return (
      <div className="flex flex-row h-screen">
         {/* AdminSidebar for choosing project */}
         <div>
            <SidebarProvider name="admin-sidebar">
               <AdminSidebar />
            </SidebarProvider>
         </div>
         <div className="flex flex-row w-full h-full">
            {/* ExplorerSidebar now shows stages/options/items hierarchy */}
            <div>
               <SidebarProvider name="stages-sidebar">
                  <ExplorerSidebar />
               </SidebarProvider>
            </div>
            <div className="w-full flex">
               <MainEditorPanel
                  currentProduct={currentProduct}
                  currentItem={currentItem || null}
                  currentStage={currentStage || null}
                  currentOption={currentOption || null}
               />
            </div>
         </div>
      </div>
   );
}
